"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectSuggestedAction = exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SUGGESTED_ACTION_CSS = (0, _glamor.css)({
  display: 'inline-block',
  whiteSpace: 'initial'
});

var connectSuggestedAction = function connectSuggestedAction() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var disabled = _ref.disabled,
        focusSendBox = _ref.focusSendBox,
        language = _ref.language,
        onCardAction = _ref.onCardAction;
    var displayText = _ref2.displayText,
        text = _ref2.text,
        type = _ref2.type,
        value = _ref2.value;
    return {
      click: function click() {
        onCardAction({
          displayText: displayText,
          text: text,
          type: type,
          value: value
        });
        focusSendBox();
      },
      disabled: disabled,
      language: language
    };
  }].concat(selectors));
};

exports.connectSuggestedAction = connectSuggestedAction;

var _default = connectSuggestedAction(function (_ref3) {
  var styleSet = _ref3.styleSet;
  return {
    styleSet: styleSet
  };
})(function (_ref4) {
  var buttonText = _ref4.buttonText,
      click = _ref4.click,
      disabled = _ref4.disabled,
      image = _ref4.image,
      styleSet = _ref4.styleSet;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(styleSet.suggestedAction + '', SUGGESTED_ACTION_CSS)
  }, _react.default.createElement("button", {
    disabled: disabled,
    onClick: click
  }, image && _react.default.createElement("img", {
    src: image
  }), _react.default.createElement("nobr", null, buttonText)));
});

exports.default = _default;